import { sendEvent } from "./sendEvent"

function initScrollDepthTracking() {
  const thresholds = [25, 50, 75, 90, 100]
  const triggered = new Set()

  const throttle = (fn, wait) => {
    let time = Date.now()
    return () => {
      if (Date.now() - time >= wait) {
        fn()
        time = Date.now()
      }
    }
  }

  const checkScrollDepth = throttle(() => {
    const { scrollHeight, scrollTop } = document.documentElement
    const scrollableHeight = scrollHeight - window.innerHeight

    if (scrollableHeight <= 0) return

    const scrolledPercent = Math.floor((scrollTop / scrollableHeight) * 100)

    for (const threshold of thresholds) {
      if (triggered.has(threshold) || scrolledPercent < threshold - 5) continue

      triggered.add(threshold)
      sendEvent("Scroll Depth", { event_detail: `${threshold}%` })

      if (triggered.size === thresholds.length) {
        window.removeEventListener("scroll", checkScrollDepth)
        break
      }
    }
  }, 250)

  window.addEventListener("scroll", checkScrollDepth, { passive: true })
}

function initGenericClick() {
  document.documentElement.addEventListener("click", (event) => {
    const url = new URL(window.location)
    const target = event.target
    const clickUrl = target.href || target.getAttribute("data-url")
    sendEvent("Generic Click", {
      Click_Class: target?.className,
      Click_Text: target?.innerText,
      Click_URL: clickUrl ?? "",
      Page_Path: url?.pathname,
      Page_URL: url?.origin,
    })
  })
}

export function initAnalytics() {
  initScrollDepthTracking()
  initGenericClick()
}
